import React, { useCallback, useEffect, useRef, useState } from "react";
import { useOutletContext, useParams } from "react-router";
import Modal from "../../../../components/Common/Modal/Modal";
import ViewContent from "../../../../containers/manage/CreateShotClass/ViewContent/ViewContent";
import { manageTranscription } from "../../../../utils/mainTabs/manage/manageTranscription";
import { useDispatch, useSelector } from "react-redux";
import classes from "./TranscribeDetails.module.scss";
import {
  getSemanticClassByIdActionHandler,
  getSemanticSectionsByIdActionHandler,
  getVideoMediaTokenActionHandler,
  updateTranscribeShotclassActionHandler,
} from "../../../../store/actions/actionHandlers/manageActionHandler";
import TransciptTagsTable from "../../../../components/Manage/ManageTranscription/TransciptTagsTable/TransciptTagsTable";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import loaders from "../../../../store/actions/actionCreators/loadersActionCreator";
import Loader from "../../../../components/Common/Loader/Loader";
import VideoPlayer from "../../../../components/Common/videoPlayer/VideoPlayer";

const TranscribeDetails = () => {
  const dispatch = useDispatch();
  const params = useParams();

  const { buttons } = manageTranscription;

  const manageState = useSelector((state) => state.manageReducer);
  const { getTranscriptionDataLoader, getClassDetailsById } = manageState;
  const [mediaKindToken, setMediaKindToken] = useState("");
  const [tableData, setTableData] = useState([]);
  const [semanticClassData, setSemanticClassData] = useState({});
  const [viewContentModal, setViewContentModal] = useState(false);
  const { formValues, setManageButtons } = useOutletContext();
  const [tagNames, setTagNames] = useState([]);

  const handleViewContentModal = useCallback(() => {
    if (
      formValues?.Other?.Mediatype === 8 ||
      formValues?.Other?.Mediatype === 9 ||
      formValues?.Other?.Mediatype === 11
    ) {
      window.open(formValues?.Other?.VideoUrl);
    } else {
      setViewContentModal(!viewContentModal);
    }
  }, [viewContentModal, formValues?.Other]);

  useEffect(() => {
    dispatch(getSemanticSectionsByIdActionHandler(params?.shotclassId)).then(
      (data) => {
        dispatch(getSemanticClassByIdActionHandler(params?.shotclassId)).then(
          (classData) => {
            setSemanticClassData(classData);
          }
        );
        let dataForTable = data?.results?.map((result) => {
          let {
            section_id,
            content_body,
            course_id,
            section_details,
            ...restResult
          } = result;
          let section_tag = section_details?.section_tags?.[0];

          return {
            section_id: section_id,
            content_body: content_body,
            course_id: course_id,
            page_no: section_details?.page_no,
            slide_no: section_details?.slide_no,
            start_time: new Date(section_details?.start_time * 1000)
              .toISOString()
              .substr(11, 8),
            end_time: new Date(section_details?.end_time * 1000)
              .toISOString()
              .substr(11, 8),
            section_tags: section_tag,
            section_details: section_details,
            restResult,
          };
        });
        setTableData(dataForTable);
        setTagNames(dataForTable);
      }
    );
  }, [params?.shotclassId, setTableData, setSemanticClassData, dispatch]);

  useEffect(() => {
    let buttonList = buttons(handleViewContentModal);
    if (formValues?.Other) {
      setManageButtons(buttonList);
    }
  }, [formValues?.Other, handleViewContentModal, buttons, setManageButtons]);

  useEffect(() => {
    if (getClassDetailsById?.AssetId) {
      dispatch(
        getVideoMediaTokenActionHandler(getClassDetailsById?.AssetId)
      ).then((res) => {
        if (res) {
          setMediaKindToken(res);
        }
      });
    }
  }, [getClassDetailsById?.AssetId, dispatch]);

  const handleSubmitData = (data, setModal) => {
    dispatch(loaders.manage.manageTransciption.addTranscribeTagLoader(true));
    let sectionData = data?.TransciptTagList?.map((tag, index) => {
      let section_details = { ...tag?.section_details, section_tags: [""] };
      return {
        contentBody: tag?.content_body,
        fields_matched: "",
        section_id: tag?.section_id,
        section_tags: tag?.section_tags ? [tag?.section_tags] : [],
        snippet: "",
        summary: "",
        section_details: section_details,
      };
    });
    let updatedData = {
      ...semanticClassData,
      indexingRequired: false,
      languageCode: "en-GB",
      sections: sectionData,
    };
    dispatch(updateTranscribeShotclassActionHandler(updatedData)).then(
      (isAdded) => {
        if (isAdded) {
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `Your ${formValues?.Other?.Name} saved successfully.`
            )
          );
        } else {
          dispatch(
            setErrorHandler(
              errorTypes.FAIL,
              `There is some error while saving.`
            )
          );
        }
        dispatch(
          loaders.manage.manageTransciption.addTranscribeTagLoader(false)
        );
        setModal(false);
        setTagNames(sectionData);
      }
    );
  };

  return (
    <div className={classes.transcribeDetails}>
      {/* <div className={classes.videoDetails}> */}
      {/* <div ref={videoElement} id="video-container"></div> */}
      {/* <VideoPlayer
          mediaKindToken={mediaKindToken}
          setMediaKindToken={setMediaKindToken}
          videoUrl={getClassDetailsById?.VideoUrl}
        /> */}
      {getTranscriptionDataLoader ? (
        <div className={classes.transcribeDetails__loader}>
          <Loader width="50" height="50" />
        </div>
      ) : (
        tableData?.length > 0 && (
          <TransciptTagsTable
            data={tableData}
            handleSubmitData={handleSubmitData}
            shotclassName={formValues?.Other?.Name}
            shotclassType={formValues?.Other?.Mediatype}
          />
        )
      )}
      {/* </div> */}
      <div className={classes.transcribeDetails__tagsAdded}>
        {tableData?.length > 0 && (
          <div className={classes.transcribeDetails__tagsAdded__heading}>
            Added Tags
          </div>
        )}
        {/* {getTranscriptionDataLoader && <Loader width="40" height="40" />} */}
        <ul className={classes.transcribeDetails__tagsAdded__tagList}>
          {tagNames?.map((tag) => {
            if (tag?.section_tags?.length > 0) {
              return (
                <li
                  key={tag?.section_id}
                  className={classes.transcribeDetails__tagsAdded__tagList__tag}
                >
                  {tag?.section_tags}
                </li>
              );
            } else {
              return <></>;
            }
          })}
        </ul>
      </div>
      <Modal
        isOpen={viewContentModal}
        toggle={() => handleViewContentModal()}
        width={"90"}
        height={"45"}
        heading={formValues?.Other?.Name}
      >
        <ViewContent
          viewContent={viewContentModal}
          shotclassData={formValues?.Other}
        />
      </Modal>
    </div>
  );
};

export default TranscribeDetails;
